

























































import Vue from 'vue'
import { range, groupBy } from 'lodash'
import moment, { Moment, MomentInput } from 'moment'

import { InterviewCalendar } from '@/queries/interviewCalendar.graphql'
import { InterviewCalendarQuery, InterviewCalendarQueryVariables } from '@/graphql-schema'

export type Interview = NonNullable<InterviewCalendarQuery['items']>['nodes'][0]

export default Vue.extend({
  apollo: {
    items: {
      query: InterviewCalendar,
      pollInterval: 10000,
      fetchPolicy: 'cache-and-network',
      variables(): InterviewCalendarQueryVariables {
        return {
          fromDatetime: this.fromDatetime,
          tilDatetime: this.tilDatetime,
        }
      },
    },
  },
  computed: {
    fromDatetime(): Moment {
      return moment(this.startOfMonth).startOf('week')
    },
    endOfMonth(): Moment {
      return moment(this.startOfMonth).endOf('month')
    },
    tilDatetime(): Moment {
      return moment(this.endOfMonth).endOf('week')
    },
    nextMonth(): Moment {
      return moment(this.startOfMonth)
        .add(1, 'month')
        .startOf('month')
    },
    previousMonth(): Moment {
      return moment(this.startOfMonth)
        .subtract(1, 'month')
        .startOf('month')
    },
    days(): Moment[] {
      const daysInRange = this.tilDatetime.diff(this.fromDatetime, 'days')
      return range(0, daysInRange + 1).map(days => moment(this.fromDatetime).add(days, 'days'))
    },
    formattedDates(): string[] {
      return this.days.map(m => this.key(m))
    },
    itemsByDate(): { [key: string]: Interview[] | undefined } {
      return groupBy(this.items!.nodes || [], item => this.key(item.startsAt))
    },
  },
  data(): { startOfMonth: Moment; items: InterviewCalendarQuery['items'] } {
    return {
      items: { nodes: [] },
      startOfMonth: moment().startOf('month'),
    }
  },
  methods: {
    key(date: MomentInput): string {
      return moment(date).format('YYYY-MM-DD')
    },
    interviewsAt(date: MomentInput): Interview[] {
      return this.itemsByDate[this.key(date)] || []
    },
    inCurrentMonth(date: MomentInput): boolean {
      return moment(date).isBetween(this.startOfMonth, this.endOfMonth, 'days', '[]')
    },
    isAvailable(offer: Interview): boolean {
      return !offer.bookedAt && offer.offerIsCanceled === false
    },
    isBooked(offer: Interview): boolean {
      return !!offer.bookedAt
    },
    isCancelledOrPast(offer: Interview): boolean {
      return offer.offerIsCanceled === true || offer.isPast === true
    },
    isAccepted(offer: Interview): boolean {
      return offer.hasTakenPlace === true && offer.accepted === true
    },
    isRejected(offer: Interview): boolean {
      return offer.hasTakenPlace === true && (offer.accepted === false || offer.accepted == null)
    },
    openCase(offer: Interview) {
      if (offer.caseId != null) {
        let url = this.$router.resolve({ name: 'admin.case', params: { caseId: offer.caseId } })
        window.open(url.href)
      }
    }
  },
})
